import { STUDY_HOW } from "../data/methodology";
import { ServiceIcon, StepIcon, TessaLogoMark } from "./MethodologyIcons";

/**
 * TESSA methodological template: the six steps as one continuous flow, then the
 * ecosystem services the toolkit covers. Same drawn-path language as the story
 * journey, in the brand green ramp.
 */
export function MethodologySchema() {
  return (
    <div className="nbs-tessa-board" data-testid="story-how-schema">
      <header className="nbs-tessa-board__header">
        <TessaLogoMark className="nbs-tessa-board__logo" />
        <div>
          <p className="nbs-tessa-board__kicker">Méthodologie TESSA</p>
          <h3 className="nbs-tessa-board__title">
            Toolkit for Ecosystem Service Site-based Assessment
          </h3>
          <p className="nbs-tessa-board__intro">{STUDY_HOW.schemaIntro}</p>
        </div>
      </header>

      <ol className="nbs-tessa-flow" aria-label="Schéma méthodologique TESSA en six étapes">
        {STUDY_HOW.schema.map((step, index) => (
          <li key={step.id} className="nbs-tessa-flow__step">
            <span className="nbs-tessa-flow__mark" aria-hidden="true">
              <span className="nbs-tessa-flow__badge">{index + 1}</span>
              <span className="nbs-tessa-flow__link" />
            </span>
            <span className="nbs-tessa-flow__tile" aria-hidden="true">
              <StepIcon icon={step.icon} className="nbs-tessa-flow__icon" />
            </span>
            <div className="nbs-tessa-flow__copy">
              <p className="nbs-tessa-flow__label">{step.title}</p>
              <p className="nbs-tessa-flow__detail">{step.detail}</p>
            </div>
          </li>
        ))}
      </ol>

      <section className="nbs-tessa-services" aria-labelledby="tessa-services-heading">
        <h4 id="tessa-services-heading" className="nbs-tessa-services__title">
          Services écosystémiques pris en compte par TESSA
        </h4>
        <ul className="nbs-tessa-services__list">
          {STUDY_HOW.services.map((service) => (
            <li key={service.id} className="nbs-tessa-services__item">
              <span className="nbs-tessa-services__icon-wrap">
                <ServiceIcon icon={service.icon} className="nbs-tessa-services__icon" />
              </span>
              <span className="nbs-tessa-services__copy">
                <strong>{service.label}</strong>
                {service.detail ? <small>{service.detail}</small> : null}
              </span>
            </li>
          ))}
        </ul>
      </section>

      <footer className="nbs-tessa-board__footer">
        <p>
          Référence :{" "}
          <a
            className="nbs-text-link"
            href={STUDY_HOW.tessa.reference.doiUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Peh et al. / BirdLife — TESSA
          </a>
        </p>
        <a
          className="nbs-text-link"
          href={STUDY_HOW.tessa.reference.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          birdlife.org/tessa-tools
        </a>
      </footer>
    </div>
  );
}
